import {useEPStore} from 'stores/ep';
import axios from 'axios';

const EPStore = useEPStore();

axios.defaults.baseURL = '/api/v2';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use((config) => {
	EPStore.spinner = true;

	return config;
}, (error) => {
	EPStore.spinner = false;

	return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
	EPStore.spinner = false;

	return response;
}, (error) => {
	EPStore.spinner = false;

	return Promise.reject(error);
});
